import React from "react";
import {
  registrationFees,
  bankingDetails,
  registrationFormUrl,
} from "../data/mockData";
import { CreditCard, CheckCircle, ExternalLink, Building2 } from "lucide-react";

const Registration = () => {
  const handleRegistrationClick = () => {
    window.open(registrationFormUrl, "_blank");
  };

  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <div className="relative bg-blue-950 py-16 text-center overflow-hidden">
        <h1 className="relative text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          REGISTRATION
        </h1>
        <div className="relative w-32 sm:w-48 h-1 bg-primary-600 mx-auto"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="text-center mb-12">
          <p className="text-xl text-gray-700">
            Register for TG-SMART 2026 and be part of the international
            conference
          </p>
        </div>

        {/* Registration Table */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden mb-12">
          {/* DESKTOP TABLE */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-blue-600 to-blue-700">
                  <th
                    rowSpan="3"
                    className="border-2 border-gray-200 px-4 py-6 text-left text-white text-xl"
                  >
                    Registration
                  </th>
                  <th
                    colSpan="4"
                    className="border-2 border-gray-200 px-4 py-4 text-center text-white text-xl"
                  >
                    India (Rs.)
                  </th>
                  <th
                    rowSpan="3"
                    className="border-2 border-gray-200 px-4 py-6 text-center text-white text-xl"
                  >
                    Foreign (USD)
                  </th>
                </tr>

                <tr className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
                  <th colSpan="2" className="border-2 px-4 py-3">
                    Early Bird
                  </th>
                  <th colSpan="2" className="border-2 px-4 py-3">
                    Regular
                  </th>
                </tr>

                <tr className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
                  <th className="border-2 px-4 py-3">IGS</th>
                  <th className="border-2 px-4 py-3">Non-IGS</th>
                  <th className="border-2 px-4 py-3">IGS</th>
                  <th className="border-2 px-4 py-3">Non-IGS</th>
                </tr>
              </thead>

              <tbody>
                {registrationFees.map((fee, index) => (
                  <tr key={index} className={fee.rowColor}>
                    <td className="border-2 px-4 py-4">{fee.category}</td>
                    <td className="border-2 px-4 py-4 text-center">
                      {fee.earlyBirdIGS}
                    </td>
                    <td className="border-2 px-4 py-4 text-center">
                      {fee.earlyBirdNonIGS}
                    </td>
                    <td className="border-2 px-4 py-4 text-center">
                      {fee.regularIGS}
                    </td>
                    <td className="border-2 px-4 py-4 text-center">
                      {fee.regularNonIGS}
                    </td>
                    <td className="border-2 px-4 py-4 text-center">
                      {fee.foreign}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* MOBILE CARD VIEW */}
          <div className="md:hidden p-4 space-y-6">
            {registrationFees.map((fee, index) => (
              <div
                key={index}
                className="bg-blue-50 rounded-xl shadow-lg p-5 border-l-4 border-blue-600"
              >
                <h3 className="text-xl font-bold text-blue-900 mb-3">
                  {fee.category}
                </h3>

                <div className="space-y-2 text-gray-800">
                  <p>
                    <span className="font-semibold">Early Bird (IGS):</span>{" "}
                    {fee.earlyBirdIGS}
                  </p>
                  <p>
                    <span className="font-semibold">Early Bird (Non-IGS):</span>{" "}
                    {fee.earlyBirdNonIGS}
                  </p>
                  <p>
                    <span className="font-semibold">Regular (IGS):</span>{" "}
                    {fee.regularIGS}
                  </p>
                  <p>
                    <span className="font-semibold">Regular (Non-IGS):</span>{" "}
                    {fee.regularNonIGS}
                  </p>
                  <p className="text-blue-900 font-bold pt-2">
                    Foreign: {fee.foreign}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Registration Includes */}
        <div className="bg-gradient-to-r from-blue-100 to-blue-200 rounded-xl p-8 mb-12 border-l-4 border-primary-600">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">
            Registration Includes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              "Conference Kit & Materials",
              "Access to All Sessions",
              "Lunch & Refreshments",
              "Conference Proceedings",
              "Certificate of Participation",
              "Networking Opportunities",
            ].map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-3 text-gray-800"
              >
                <CheckCircle
                  size={20}
                  className="text-green-600 flex-shrink-0"
                />
                <span className="font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Registration Form Button */}
        <div className="bg-gradient-to-r from-blue-100 to-blue-200 rounded-xl p-8 text-center border-t-4 border-primary-600 mb-8">
          <CreditCard size={64} className="mx-auto mb-4 text-primary-600" />
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Complete Your Registration
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Fill out the registration form and submit payment details
          </p>
          <button
            onClick={handleRegistrationClick}
            className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white px-10 py-4 rounded-lg font-semibold text-lg transition-all hover:scale-105 shadow-lg"
          >
            <ExternalLink size={24} />
            Open Registration Form
          </button>
        </div>

        {/* Banking Details */}

        {/* Instructions */}
        <div className="bg-green-50 border-l-4 border-green-600 rounded-lg p-6">
          <h3 className="text-2xl font-bold text-green-900 mb-4">
            Registration Instructions
          </h3>
          <ol className="list-decimal list-inside space-y-2 text-green-800">
            <li>Click the "Open Registration Form" button above</li>
            <li>Fill in all required details in the Google Form</li>
            <li>
              Transfer the registration fee to the bank account mentioned above
            </li>
            <li>Upload the payment receipt/screenshot in the form</li>
            <li>You will receive a confirmation email within 48 hours</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Registration;
